export default __webpack_public_path__ + "static/media/TicTacToe.be9173a5.png";